import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

const PaymentsService = {
  getAccountsWithStripeId: (stripeId: string) =>
    requests(SERVICE_NAME.PAYMENTS_API).get(
      `stripe/accounts?stripeId=${stripeId}`
    ),
};

export default PaymentsService;
